module.exports = __webpack_public_path__ + "logo.svg?97bb07529d4d0e791af830d2fed64be4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 1044
// module chunks = 0